/**
 * VehicleGrid Feature Component
 * Grid display for vehicle cards with load more functionality
 */

'use client'

import { VehicleCard } from '@/components/organisms/VehicleCard'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Car, CarCategory } from '@/types'

const categoryLabel: Record<CarCategory, string> = {
	economy: 'Económico',
	compact: 'Compacto',
	midsize: 'Mediano',
	fullsize: 'Estándar',
	suv: 'SUV',
	luxury: 'Lujo',
	van: 'Van',
	pickup: 'Pickup',
}

interface VehicleGridProps {
	vehicles: Car[]
	onReserve?: (vehicleId: string) => void
	onLoadMore?: () => void
	hasMore?: boolean
	isLoading?: boolean
	className?: string
}

export function VehicleGrid({
	vehicles,
	onReserve,
	onLoadMore,
	hasMore = false,
	isLoading = false,
	className,
}: VehicleGridProps) {
	return (
		<div className={cn('py-8 px-[3%] bg-gray-50', className)}>
			{/* Vehicle Grid */}
			<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8'>
				{vehicles.map(vehicle => (
					<VehicleCard
						key={vehicle.id}
						id={vehicle.id}
						name={`${vehicle.brand} ${vehicle.model}`}
						imageUrl={vehicle.images[0]?.url || ''}
						transmission={
							vehicle.specifications.transmission === 'automatic'
								? 'Automático'
								: 'Manual'
						}
						category={categoryLabel[vehicle.category] ?? vehicle.category}
						doors={vehicle.specifications.doors}
						passengers={vehicle.specifications.seats}
						luggage={vehicle.specifications.luggage}
						fuelType={
							vehicle.originalOffer?.groupDetail?.fuel ||
							vehicle.specifications.fuelType
						}
						dailyRate={vehicle.pricing.dailyRate}
						totalRate={vehicle.pricing.weeklyRate || vehicle.pricing.dailyRate}
						onReserve={onReserve}
					/>
				))}
			</div>

			{/* Load More Button */}
			{hasMore && (
				<div className='flex justify-center'>
					<Button
						onClick={onLoadMore}
						disabled={isLoading}
						className='bg-[#09194D] hover:bg-[#09194D]/90 text-[#CDFF00] font-["Bricolage_Grotesque"] text-sm font-black px-8 py-3 h-auto rounded-full border-2 border-[#CDFF00] cursor-pointer'
					>
						{isLoading ? 'Cargando...' : 'Cargar más'}
					</Button>
				</div>
			)}

			{/* Empty State */}
			{vehicles.length === 0 && !isLoading && (
				<div className='flex flex-col items-center justify-center py-16'>
					<p className='font-["Bricolage_Grotesque"] text-lg text-gray-600 text-center'>
						No se encontraron vehículos en esta categoría.
					</p>
				</div>
			)}
		</div>
	)
}
